<template>
    <div>
        <p>After graduating from the University of Colorado at Boulder, I accepted a Software Engineer position at the start-up Funeral Innovations (FI). Here I acted as a full stack developer building a web app from the ground up. In addition I performed dev ops duties as well as code testing. I worked with many APIs including Facebook, Google Ads, Stripe, and Twilio to name a few.</p>
        <photo-shelf>
            <photo-frame
                class="frame"
                :src="getImageUrl('FuneralInnovations.jpeg')"
                text="Team bonding at an escape room in Boulder."
                location="Pearl St. Boulder"
            />
        </photo-shelf>
        <logo-scroller :logos="logos"><p>Tech used:</p></logo-scroller>
    </div>
</template>

<script>
    import PhotoShelf from '@/components/PhotoShelf'
    import PhotoFrame from '@/components/PhotoFrame'
    import LogoScroller from '@/components/LogoScroller'

    export default {
        name: "FiTimeline",
        components: {
            PhotoFrame,
            PhotoShelf,
            LogoScroller
        },
        data () {
            return {
                logos: [
                    'php',
                    'cakephp',
                    'php_unit',
                    'js',
                    'html5',
                    'css3',
                    'sass',
                    'vue',
                    'jest',
                    'aws',
                    'docker',
                    'git_hub',
                    'bit_bucket',
                    'git',
                    'npm',
                    'webpack',
                    'google_ads',
                    'stripe',
                    'twilio'
                ]
            } 
        },
    }
</script>

<style>

</style>